/**
 * Lightweight scroll-triggered count-up for MDB Trust Stats.
 * No dependencies. Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  var DURATION_MS = 1800;
  var prefersReduced =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatNumber(value, decimals) {
    var fixed = Number(value).toFixed(decimals);
    if (decimals > 0) {
      var parts = fixed.split('.');
      parts[0] = Number(parts[0]).toLocaleString('en-AU');
      return parts.join('.');
    }
    return Number(fixed).toLocaleString('en-AU');
  }

  function animateCount(el) {
    if (el.dataset.mdbCounted === 'true') return;
    el.dataset.mdbCounted = 'true';

    var end = parseFloat(el.dataset.end || '0');
    var decimals = parseInt(el.dataset.decimals || '0', 10);
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var duration = parseInt(el.dataset.duration || String(DURATION_MS), 10);

    if (prefersReduced || !isFinite(end) || duration <= 0) {
      el.textContent = prefix + formatNumber(end, decimals) + suffix;
      return;
    }

    var startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = end * eased;
      el.textContent = prefix + formatNumber(current, decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = prefix + formatNumber(end, decimals) + suffix;
      }
    }

    requestAnimationFrame(frame);
  }

  function observeSection(section) {
    var counters = section.querySelectorAll('[data-mdb-count]');
    if (!counters.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.querySelectorAll('[data-mdb-count]').forEach(animateCount);
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.35, rootMargin: '0px 0px -8% 0px' }
    );

    io.observe(section);
  }

  function init() {
    document.querySelectorAll('[data-mdb-trust-stats]').forEach(observeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-render
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector('[data-mdb-trust-stats]');
    if (section) observeSection(section);
  });
})();
